import React, { useState } from 'react';
import { Card, Badge, Modal } from 'react-bootstrap';
import { FaCirclePlay, FaClock } from 'react-icons/fa6';
import { Video } from '../../types/tutorials.types';
import './VideoGrid.scss';

interface VideoGridProps {
  videos: Video[];
}

const VideoGrid: React.FC<VideoGridProps> = ({ videos }) => {
  const [selectedVideo, setSelectedVideo] = useState<Video | null>(null);

  const handleVideoClick = (video: Video) => {
    setSelectedVideo(video);
  };

  const handleCloseModal = () => {
    setSelectedVideo(null);
  };

  const getYouTubeThumbnail = (youtubeId: string) => {
    return `https://img.youtube.com/vi/${youtubeId}/maxresdefault.jpg`;
  };

  if (videos.length === 0) {
    return (
      <div className="no-videos">
        <p>No se encontraron videos que coincidan con tu búsqueda.</p>
      </div>
    );
  }

  return (
    <>
      <div className="video-grid">
        {videos.map((video) => (
          <Card
            key={video.id}
            className="video-card"
            onClick={() => handleVideoClick(video)}
          >
            <div className="video-thumbnail">
              <img
                src={getYouTubeThumbnail(video.youtubeId)}
                alt={video.title}
                onError={(e) => {
                  // Fallback to default thumbnail if maxresdefault doesn't exist
                  e.currentTarget.src = `https://img.youtube.com/vi/${video.youtubeId}/hqdefault.jpg`;
                }}
              />
              <div className="play-overlay">
                <FaCirclePlay />
              </div>
              {video.isNew && (
                <Badge bg="danger" className="new-badge">
                  NUEVO
                </Badge>
              )}
              <div className="duration-badge">
                <FaClock /> {video.duration}
              </div>
            </div>
            <Card.Body>
              <Card.Title>{video.title}</Card.Title>
              <Card.Text>{video.description}</Card.Text>
            </Card.Body>
          </Card>
        ))}
      </div>

      {/* Video Player Modal */}
      <Modal
        show={!!selectedVideo}
        onHide={handleCloseModal}
        size="xl"
        centered
        className="tutorial-video-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>{selectedVideo?.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedVideo && (
            <div className="video-player-container">
              <iframe
                width="100%"
                height="500"
                src={`https://www.youtube.com/embed/${selectedVideo.youtubeId}?autoplay=1`}
                title={selectedVideo.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
              <div className="video-info">
                <p className="video-description">{selectedVideo.description}</p>
                <div className="video-stats">
                  <span>
                    {new Date(selectedVideo.publishedDate).toLocaleDateString('es-MX', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                    })}
                  </span>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default VideoGrid;
